import api from ".";

export const obterSetores = async (obj) => {
    try {
        const { data } = await api.post("setor/obterSetores", obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
